const numberRegex = /^\d+?$/;

export {
  numberRegex,
};
